// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1zDav","inner":"Form_inner__3VM60","range":"Form_range__K7mqw","name":"Form_name__2FnZu","actions":"Form_actions__2-40U"};